var stickObject = {
    "playerGoalieSticks": [
      {
        "SKU": "688698552195",
        "VariantID": "43274812260605"
      },
      {
        "SKU": "688698403497",
        "VariantID": "43274778149117"
      },
      {
        "SKU": "688698552188",
        "VariantID": "43274786767101"
      },
      {
        "SKU": "688698403503",
        "VariantID": "43274771988733"
      }, {
        "SKU": "688698403510",
        "VariantID": "43274778935549"
      }, {
        "SKU": "688698403527",
        "VariantID": "43274780672253"
      }, {
        "SKU": "688698403534",
        "VariantID": "43274780606717"
      }, {
        "SKU": "688698403541",
        "VariantID": "43274775429373"
      }, {
        "SKU": "688698403558",
        "VariantID": "43274772873469"
      }, {
        "SKU": "688698403565",
        "VariantID": "43274776674557"
      }, {
        "SKU": "688698403572",
        "VariantID": "43274777264381"
      }, {
        "SKU": "688698402148",
        "VariantID": "43274776838397"
      }, {
        "SKU": "688698402155",
        "VariantID": "43274778345725"
      }, {
        "SKU": "688698402162",
        "VariantID": "43274776215805"
      }, {
        "SKU": "688698403589",
        "VariantID": "43274780934397"
      }, {
        "SKU": "688698403596",
        "VariantID": "43274778804477"
      }, {
        "SKU": "688698403602",
        "VariantID": "43274780737789"
      }, {
        "SKU": "688698342093",
        "VariantID": "43274772775165"
      }, {
        "SKU": "688698402070",
        "VariantID": "43274774937853"
      }, {
        "SKU": "688698342086",
        "VariantID": "43274774413565"
      }, {
        "SKU": "688698402049",
        "VariantID": "43274777362685"
      }, {
        "SKU": "688698402056",
        "VariantID": "43274771890429"
      }, {
        "SKU": "688698465945",
        "VariantID": "43274772906237"
      }, {
        "SKU": "688698465938",
        "VariantID": "43274777493757"
      }, {
        "SKU": "688698423495",
        "VariantID": "43274777067773"
      }, {
        "SKU": "688698423501",
        "VariantID": "43274781229309"
      }, {
        "SKU": "688698423518",
        "VariantID": "43274773725437"
      }, {
        "SKU": "688698424478",
        "VariantID": "43274775036157"
      }, {
        "SKU": "688698424461",
        "VariantID": "43274773528829"
      }, {
        "SKU": "688698424485",
        "VariantID": "43274779492605"
      }, {
        "SKU": "688698507157",
        "VariantID": "43274772545789"
      }, {
        "SKU": "688698507140",
        "VariantID": "43274778083581"
      }, {
        "SKU": "688698507133",
        "VariantID": "43274774774013"
      }, {
        "SKU": "688698507126",
        "VariantID": "43274777002237"
      }, {
        "SKU": "688698483369",
        "VariantID": "43274773070077"
      }, {
        "SKU": "688698483376",
        "VariantID": "43274771562749"
      }, {
        "SKU": "688698483994",
        "VariantID": "43274778181885"
      }, {
        "SKU": "688698484007",
        "VariantID": "43274780213501"
      }, {
        "SKU": "688698503999",
        "VariantID": "43274773397757"
      }, {
        "SKU": "688698504002",
        "VariantID": "43274774380797"
      }, {
        "SKU": "688698504019",
        "VariantID": "43274775691517"
      }, {
        "SKU": "688698554083",
        "VariantID": "43274775003389"
      }, {
        "SKU": "688698554090",
        "VariantID": "43274774708477"
      }, {
        "SKU": "688698552164",
        "VariantID": "43274807116029"
      }, {
        "SKU": "688698552171",
        "VariantID": "43274826187005"
      }, {
        "SKU": "688698616125",
        "VariantID": "43624514912509"
      }, {
        "SKU": "688698616156",
        "VariantID": "43624514945277"
      }, {
        "SKU": "688698616132",
        "VariantID": "43624515010813"
      }, {
        "SKU": "688698616149",
        "VariantID": "43624514978045"
      }, {
        "SKU": "688698614237",
        "VariantID": "43945553527037"
      }, {
        "SKU": "688698614220",
        "VariantID": "43945553494269"
      }, {
        "SKU": "688698614244",
        "VariantID": "43945553559805"
      }, {
        "SKU": "688698614251",
        "VariantID": "43945553592573"
      }, {
        "SKU": "688698403589",
        "VariantID": "43274780934397"
      }, {
        "SKU": "688698403596",
        "VariantID": "43274778804477"
      }, {
        "SKU": "688698403602",
        "VariantID": "43274780737789"
      }, {
        "SKU": "688698621334",
        "VariantID": "43996936569085"
      }, {
        "SKU": "688698621341",
        "VariantID": "43996936667389"
      }, {
        "SKU": "688698621358",
        "VariantID": "43996936601853"
      }, {
        "SKU": "688698621365",
        "VariantID": "43996936634621"
      }, {
        "SKU": "688698648607",
        "VariantID": "44168868692221"
      }, {
        "SKU": "688698648621",
        "VariantID": "44168868790525"
      }, {
        "SKU": "688698648614",
        "VariantID": "44168868757757"
      }, {
        "SKU": "688698648591",
        "VariantID": "44168868724989"
      },{
        "SKU": "688698684247",
        "VariantID": "44514518663421"
      },{
        "SKU": "688698684230",
        "VariantID": "44514518597885"
      },{
        "SKU": "688698705935",
        "VariantID": "44514518630653"
      },
      {
        "SKU": "688698673036",
        "VariantID": "45443179643133"
      },
      {
        "SKU": "688698673043",
        "VariantID": "45443179708669"
      },
      {
        "SKU": "688698673050",
        "VariantID": "45443179610365"
      },
      {
        "SKU": "688698673067",
        "VariantID": "45443179675901"
      },
      {
        "SKU": "688698763966",
        "VariantID": "45779942080765"
      },
      {
        "SKU": "688698763973",
        "VariantID": "45779942015229"
      },
       {
        "SKU": "688698763980",
        "VariantID": "45779942113533"
      },
      {
        "SKU": "688698763959",
        "VariantID": "45779942047997"
      },
      {
        "SKU": "688698763997",
        "VariantID": "45779942146301"
      }
    ],
    "quickTurnSticks": [
      {
        "SKU": "ULTRAS_LP_JR5",
        "VariantID": "43274787094781"
      },
      {
        "SKU": "ULTRAS_LP_JR4",
        "VariantID": "43274793517309"
      },
      {
        "SKU": "HYPERL_LP_SR",
        "VariantID": "43274788602109"
      },
      {
        "SKU": "HYPERL_LP_INT",
        "VariantID": "43274823041277"
      }, {
        "SKU": "HYPERL_LP_JR5",
        "VariantID": "43274818748669"
      }, {
        "SKU": "HYPERL_LP_JR4",
        "VariantID": "43274805608701"
      }, {
        "SKU": "SYNCN_LP_SR",
        "VariantID": "43274786242813"
      }, {
        "SKU": "SYNCN_LP_INT",
        "VariantID": "43274789355773"
      }, {
        "SKU": "SYNCN_LP_JR5",
        "VariantID": "43274786996477"
      }, {
        "SKU": "SYNCN_LP_JR4",
        "VariantID": "43274803871997"
      }, {
        "SKU": "ULTRAS_LP_SR",
        "VariantID": "43274788765949"
      }, {
        "SKU": "ULTRAS_LP_INT",
        "VariantID": "43274819830013"
      }, {
        "SKU": "HYPERL2_LP_JR4",
        "VariantID": "44002613690621"
      }, {
        "SKU": "HYPERL2_LP_JR5",
        "VariantID": "44002613362941"
      }, {
        "SKU": "HYPERL2_LP_INT",
        "VariantID": "44002613297405"
      }, {
        "SKU": "HYPERL2_LP_SR",
        "VariantID": "44002613199101"
      },
      {
        "SKU": "PROTOR_LP_INT",
        "VariantID": "44168868856061"
      },
      {
        "SKU": "PROTOR_LP_JR4",
        "VariantID": "44168868921597"
      },
      {
        "SKU": "PROTOR_LP_JR5",
        "VariantID": "44168868888829"
      },
      {
        "SKU": "PROTOR_LP_SR",
        "VariantID": "44168868823293"
      }
    ]
  };

  var bladeObject = {
    "blades": [
      {
        "SKU": "688698463569",
        "VariantID": "43274774315261"
      },
      {
        "SKU": "688698463576",
        "VariantID": "43274772709629"
      },
      {
        "SKU": "688698512878",
        "VariantID": "43274777592061"
      },
      {
        "SKU": "688698627046",
        "VariantID": "43951905079549"
      }, {
        "SKU": "688698627039",
        "VariantID": "43951905046781"
      }
    ]
  };

  var skateObject = {
    "skates": [
      {
        "SKU": "688698582178",
        "VariantID": "43274777985277"
      },
      {
        "SKU": "688698582154",
        "VariantID": "43274774905085"
      },
      {
        "SKU": "688698582215",
        "VariantID": "43274779427069"
      },
      {
        "SKU": "688698582147",
        "VariantID": "43274780967165"
      }, {
        "SKU": "688698582208",
        "VariantID": "43274781196541"
      }, {
        "SKU": "688698582192",
        "VariantID": "43274781491453"
      }, {
        "SKU": "688698582185",
        "VariantID": "43274771726589"
      }, {
        "SKU": "688698582161",
        "VariantID": "43274776903933"
      }, {
        "SKU": "688698512861",
        "VariantID": "43274779656445"
      }, {
        "SKU": "688698512854",
        "VariantID": "43274774642941"
      }, {
        "SKU": "688698512847",
        "VariantID": "43274773201149"
      }, {
        "SKU": "688698512830",
        "VariantID": "43274779132157"
      }, {
        "SKU": "688698512823",
        "VariantID": "43274771857661"
      }, {
        "SKU": "688698512816",
        "VariantID": "43274773856509"
      }, {
        "SKU": "688698512809",
        "VariantID": "43274772676861"
      }, {
        "SKU": "688698512793",
        "VariantID": "43274776543485"
      }, {
        "SKU": "688698512113",
        "VariantID": "42997164474606"
      }, {
        "SKU": "688698511796",
        "VariantID": "42997164179694"
      }, {
        "SKU": "688698511789",
        "VariantID": "42997164146926"
      }, {
        "SKU": "688698390636",
        "VariantID": "42997151105262"
      }, {
        "SKU": "688698595659",
        "VariantID": "43945553625341"
      }, {
        "SKU": "688698595673",
        "VariantID": "43945553690877"
      }, {
        "SKU": "688698595680",
        "VariantID": "43945553723645"
      }, {
        "SKU": "688698595666",
        "VariantID": "43945553658109"
      }
    ],
    "blades": [
      {
        "BladeType": "LS Pulse Ti",
        "SKU": "688698463569",
        "VariantID": "43274774315261"
      },
      {
        "BladeType": "LS Pulse TI",
        "SKU": "688698463569",
        "VariantID": "43274774315261"
      },
      {
        "BladeType": "LS Pulse",
        "SKU": "688698463576",
        "VariantID": "43274772709629"
      },
      {
        "BladeType": "LS CarbonLite",
        "SKU": "688698512878",
        "VariantID": "43274777592061"
      }, {
        "BladeType": "FLY-TI",
        "SKU": "688698627039",
        "VariantID": "43951905046781"
      }, {
        "BladeType": "FLY-X",
        "SKU": "688698627046",
        "VariantID": "43951905079549"
      }
    ]
  };

// Initialize myBauer stick object
  window.addEventListener("DOMContentLoaded", function() {
    stickObject;
    bladeObject;
    skateObject;
  })